import { Component, inject, Output, EventEmitter, signal, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CurrentUserService } from '../../../services/current-user.service';
import { SCOPES } from '../../../services/scope/scope-constants';
import { HasScopeDirective } from '../../../services/scope/has-scope.directive';
import { CartIcon } from '../../../shared/ui/icons/cart-icon/cart-icon';
import { ChevronBottomIcon } from "../../../shared/ui/icons/chevron-bottom-icon/chevron-bottom-icon";
import { FileTextIcon } from "../../../shared/ui/icons/file-text-icon/file-text-icon";
import { DocumentWithBookmarkIcon } from "../../../shared/ui/icons/document-with-bookmark-icon/document-with-bookmark-icon";
import { DocumentOrderIcon } from '../../../shared/ui/icons/document-order-icon/document-order-icon';

@Component({
  selector: 'app-user-sidebar',
  imports: [RouterLink, RouterLinkActive, HasScopeDirective, CartIcon, ChevronBottomIcon, FileTextIcon, DocumentWithBookmarkIcon, DocumentOrderIcon],
  templateUrl: './user-sidebar.html',
  styleUrl: './user-sidebar.scss',
})
export class UserSidebar implements OnInit {
  readonly SCOPES = SCOPES;

  private router = inject(Router);
  private currentUserService = inject(CurrentUserService);

  @Output() sidebarToggle = new EventEmitter<void>();
  isInvoicesOpen = signal(false);

  isInvoicesActive(): boolean {
    return this.router.url.startsWith('/user/invoices') || this.router.url.startsWith('/user/payment-requests');
  }

  ngOnInit(): void {
    this.isInvoicesOpen.set(this.isInvoicesActive());

    this.router.events.subscribe(() => {
      if (this.isInvoicesActive()) {
        this.isInvoicesOpen.set(true);
      }
    });
  }

  hideSidebar() {
    this.sidebarToggle.emit();
  }

  isActive(route: string): boolean {
    return this.router.url.startsWith(route);
  }

  logout() {
    this.currentUserService.logout();
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  isDashboardActive(): boolean {
    return this.router.url === '/user';
  }

  goToInvoices(event: Event) {
    event.stopPropagation();

    this.isInvoicesOpen.update((v) => !v);

    if (!this.isInvoicesActive()) {
      this.router.navigate(['/user/invoices']);
    }
  }


  isOrdersOpen = signal(false);

toggleOrders(): void {
  this.isOrdersOpen.update((value) => !value);

  if (!this.router.url.startsWith('/user/orders')) {
    this.router.navigate(['/user/orders']);
  }
}
isOrdersActive(): boolean {
  return this.router.url.startsWith('/user/orders') ||
         this.router.url.startsWith('/user/returns');
}

}